export default "__VITE_ASSET__CEb8azPx__"